module.exports = __webpack_public_path__ + "img/app8.8a7498ca.png";